/* AfterShed free gifts (14-10, Thomas). Works for every purchase form that contains [data-r3-gifts] (product page and
   the quiz result, which clones its form from a template, hence the delegated listeners on document).
   - On submit the form posts items[] to /cart/add: the system (with its selling plan when Autoship is ticked),
     1 Full Hair Program and 1 Needle Head per month of supply (1, 2 or 4). Gift lines carry no selling plan, so they
     ship with the first order only.
   - The block follows the chosen supply: Needle Head count, and the free shipping card only when shipping is free
     (Autoship, or a one-time order from $75).
   - On /cart: gifts without the system are removed, and the Needle Head count is set back to the months in the cart. */
(function () {
  if (window.__asGifts) return;
  window.__asGifts = true;

  /* SKU's = CJdropshipping-SKU's sinds 14-10; oude AS-*-codes blijven herkend voor carts van daarvoor. */
  var SYS_MONTHS = { 'CJYD289664801AZ': 1, 'CJYD289664802BY': 2, 'CJYD289664805EV': 4, 'AS-SYS-1M': 1, 'AS-SYS-2M': 2, 'AS-SYS-4M': 4 };
  var NEEDLE = { 'CJYD289664806FU': 1, 'AS-GIFT-NEEDLE': 1 };
  var FREE_FROM = 75;

  function chosen(form) { return form.querySelector('[data-r3-variant-choice]:checked'); }
  function months(form) { var c = chosen(form); return c ? parseInt(c.getAttribute('data-months'), 10) || 1 : 1; }
  function autoship(form) { var a = form.querySelector('[data-r3-autoship]'); return !!(a && a.checked && !a.disabled); }
  function price(el) { return parseFloat(String(el || '').replace(/[^0-9.]/g, '')) || 0; }

  function update(form) {
    var box = form.querySelector('[data-r3-gifts]');
    if (!box) return;
    var m = months(form);
    var q = box.querySelector('[data-r3-gift-qty]');
    if (q) { q.textContent = m + 'x'; q.hidden = m <= 1; }
    var nw = box.querySelector('[data-r3-gift-needle-was]');
    if (nw) { var v = 12.5 * m; nw.textContent = '$' + (v % 1 ? v.toFixed(2) : v); }
    var c = chosen(form);
    var plan = c ? c.getAttribute('data-plan') : '';
    var free = (autoship(form) && !!plan) || (c && price(c.getAttribute('data-price')) >= FREE_FROM);
    var ship = box.querySelector('[data-r3-gift-ship]');
    if (ship) ship.hidden = !free;
  }

  function hidden(form, name, value) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = name; i.value = value; i.setAttribute('data-gift-gen', '');
    form.appendChild(i);
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form');
    if (form && form.querySelector('[data-r3-gifts]')) setTimeout(function () { update(form); }, 0);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var box = form && form.querySelector && form.querySelector('[data-r3-gifts]');
    if (!box) return;
    var vIn = form.querySelector('[data-r3-variant-input]');
    if (!vIn || !vIn.value) return;
    var pIn = form.querySelector('[data-r3-plan-input]');
    var qIn = form.querySelector('input[name="quantity"]');
    form.querySelectorAll('[data-gift-gen]').forEach(function (n) { n.remove(); });
    hidden(form, 'items[0][id]', vIn.value);
    hidden(form, 'items[0][quantity]', '1');
    if (pIn && !pIn.disabled && pIn.value) hidden(form, 'items[0][selling_plan]', pIn.value);
    hidden(form, 'items[1][id]', box.getAttribute('data-program'));
    hidden(form, 'items[1][quantity]', '1');
    hidden(form, 'items[2][id]', box.getAttribute('data-needle'));
    hidden(form, 'items[2][quantity]', String(months(form)));
    [vIn, pIn, qIn].forEach(function (n) { if (n) { n.setAttribute('data-gift-off', n.disabled ? '1' : '0'); n.disabled = true; } });
  }, true);

  /* Back button (bfcache): restore the plain fields so the page keeps working as before. */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-gift-gen]').forEach(function (n) { n.remove(); });
    document.querySelectorAll('[data-gift-off]').forEach(function (n) { n.disabled = n.getAttribute('data-gift-off') === '1'; n.removeAttribute('data-gift-off'); });
    document.querySelectorAll('form').forEach(function (f) { if (f.querySelector('[data-r3-gifts]')) update(f); });
  });

  /* /cart: keep the gift lines honest. Gifts without the system are removed; Needle Heads = months of system in the cart. */
  function cartGuard() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var m = 0, upd = {}, change = false;
      cart.items.forEach(function (it) { if (SYS_MONTHS[it.sku]) m += SYS_MONTHS[it.sku] * it.quantity; });
      cart.items.forEach(function (it) {
        var want = null;
        if (NEEDLE[it.sku]) want = m;
        else if (it.sku === 'AS-GIFT-PROGRAM') want = m > 0 ? 1 : 0;
        if (want !== null && want !== it.quantity) { upd[it.key] = want; change = true; }
      });
      if (!change) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
        .then(function () { location.reload(); });
    }).catch(function () {});
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    cartGuard();
    document.querySelectorAll('form').forEach(function (f) { if (f.querySelector('[data-r3-gifts]')) update(f); });
  });
})();
